<template>
  <div id="app" ref="app_zoom">
    <!-- <Index></Index> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
// import Index from '@/layout/index.vue';
// import drawMixin from "@/utils/drawMixin.js";
export default {
  data() {
    return {
      cachedViews: [],
    };
  },
  components: {
    // Index
  },
  methods: {},
  // mixins: [drawMixin],
};
</script>

<style lang="less">
#app {
  // min-width: 1920px;
  font-family: "Avenir", Helvetica, Arial, sans-serif, PingFang-SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* http://meyerweb.com/eric/tools/css/reset/
		v2.0 | 20110126
		License: none (public domain)
	*/
html {
  margin: 0;
  padding: 0;
  /*font-size: inherit!important;*/
  font-size: 16px;
  // overflow-y: auto;
  background-color: #fcfcfc;
  // overflow-x: hidden;
}
body {
  /*box-sizing: border-box;*/
  margin: 0;
  padding: 0;
}
* {
  /*margin: 0;*/
  /*padding: 0;*/
  /*border: 0;*/
  /*vertical-align: baseline;*/
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  /*margin: 0;*/
  /*padding: 0;*/
  /*border: 0;*/
  /*font-size: 100%;*/
  /*font: inherit;*/
  /*vertical-align: baseline;*/
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  // line-height: 0;
  width: 100vw;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Arial, sans-serif;
  // //background-color: #f7f7f7ff;
}
ol,
ul {
  list-style: unset !important;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
a {
  text-decoration: none;
  color: #333;
}
img {
  vertical-align: middle;
}

input,
button,
select
// ,
// textarea
 {
  outline: none;
}

// textarea {
//   resize: none;
// }

// 通用样式
.common-title {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 56px;
}

.common-title .line {
  display: inline-block;
  width: 8px;
  height: 22px;
  margin-right: 13px;
  background: #46b942;
  border-radius: 4px;
}

.common-title .common-title-content {
  font-size: 22px;
  font-family: PingFang-SC;
  font-weight: bold;
  color: #46b942;
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
/* 滚动条的轨道 */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #55555580;
  box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
  border-radius: 3px;
}
*::-webkit-scrollbar {
  display: none;
}
// input类型为number时 去掉小箭头
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
.el-select-dropdown__item.selected {
  // color: #46B942;
}
.el-pagination {
  // 分页
  margin: 20px 0 20px 0 !important;
}
.el-input__inner:focus,
.el-input__inner:active,
.el-input__inner:hover {
  // 输入框聚焦
  border-color: rgba(61, 152, 249, 0.366);
  box-shadow: 0px 0px 8px 0px rgba(61, 152, 249, 0.14);
}
.login .el-textarea__inner:focus {
  border-color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-pagination .el-select .el-input .el-input__inner:hover {
  // 下拉框鼠标器移入
  border-color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%) !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-checkbox__inner {
  border-color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
  border-color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
  background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-radio__input.is-checked + .el-radio__label {
  color: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-radio__inner:hover {
  border: 1px solid linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
}
.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
.el-dialog__title {
  font-size: 20px;
  font-weight: 600;
}
.dialog-footer {
  .el-button--info {
    height: 35px;
    border: none;
    background: #f2f3f5;
    color: #323233;
  }
  .el-button--info:hover {
    height: 35px;
    border: none;
    background: #fafafb;
    color: #323233;
  }
  .el-button--primary {
    border: none;
    height: 36px;
    color: #ffffff;
    background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
  }

  .el-button--primary:hover {
    border: none;
    height: 36px;
    background: #dd3939;
    color: #ffffff;
  }
}
.NewsDetail {
  .theDesc {
    img {
      width: 100% !important;
      height: 100% !important;
    }
    p {
      font-size: 16px;
    }
  }
}
.van-sticky--fixed {
  z-index: 9 !important;
}
</style>
